export default function validateIp(ip) {
  if (!ip || typeof ip !== 'string' || ip.trim() === '') {
    return false;
  }
  const cleaned = ip.replace(/\s/g, '').replace(/_/g, '');
  if (cleaned.length === 0) {
    return false;
  }
  const parts = cleaned.split('.').filter(part => part !== '');
  if (parts.length !== 4) {
    return false;
  }
  return parts.every((part) => {
    if (part === '' || part.length === 0) {
      return false;
    }
    const num = parseInt(part, 10);
    return !Number.isNaN(num) && num >= 0 && num <= 255;
  });
}
